// src/icons/Icon.tsx
import { jsx } from "react/jsx-runtime";
var Icon = ({
  icon: IconComponent,
  size = 24,
  color,
  weight = "regular"
}) => /* @__PURE__ */ jsx(IconComponent, { size, color, weight });
Icon.displayName = "Icon";

export {
  Icon
};
//# sourceMappingURL=chunk-HGGC2VGG.mjs.map